{
  "title": "Silent Image",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level illusion",
  "level": 1,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a bit of fleece)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "You create the image of an object, a creature, or some other visible phenomenon that is no larger than a 15-foot cube. The image appears at a spot within range and lasts for the duration. The image is purely visual; it isn’t accompanied by sound, smell, or other sensory effects.",
    "You can use your action to cause the image to move to any spot within range. As the image changes location, you can alter its appearance so that its movements appear natural for the image. For example, if you create an image of a creature and move it, you can alter the image so that it appears to be walking.",
    "Physical interaction with the image reveals it to be an illusion, because things can pass through it. A creature that uses its action to examine the image can determine that it is an illusion with a successful Intelligence (Investigation) check against your spell save DC. If a creature discerns the illusion for what it is, the creature can see through the image."
  ],
  "spellLists": ["bard", "arcane-trickster", "sorcerer", "wizard"]
}
